/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatBRL, formatPercent } from './constants';

const SegmentComparisonTable = ({ items, totalGasto, loading, onSelectSegment }) => {
  if (loading) {
    return <Skeleton variant="rounded" height={280} />;
  }

  if (!items?.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
        Sem segmentos com custo no período.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ maxHeight: 360 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Segmento</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>Total</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>%</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>Veículos</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => {
            const percent =
              row.percentual != null
                ? row.percentual
                : totalGasto > 0
                  ? (row.total / totalGasto) * 100
                  : 0;
            return (
              <TableRow
                key={row.key ?? row.label}
                hover
                onClick={() => onSelectSegment?.(row.key, row.label)}
                sx={{ cursor: onSelectSegment ? 'pointer' : 'default' }}
              >
                <TableCell sx={{ fontWeight: 600 }}>{row.label}</TableCell>
                <TableCell align="right">{formatBRL(row.total)}</TableCell>
                <TableCell align="right">{formatPercent(percent)}</TableCell>
                <TableCell align="right">{row.quantidadeVeiculos ?? '—'}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SegmentComparisonTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  totalGasto: PropTypes.number,
  loading: PropTypes.bool,
  onSelectSegment: PropTypes.func,
};

SegmentComparisonTable.defaultProps = {
  items: [],
  totalGasto: 0,
  loading: false,
  onSelectSegment: null,
};

export default SegmentComparisonTable;
